module.exports = __webpack_public_path__ + "static/media/form.472a331c.png";